import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import { type Observable, of } from 'rxjs';

import { WithArtifactService } from '@app/assets/common/artifact.service';
import { WithAuditService } from '@app/assets/common/audit.service';
import { type TestCodeEvent, TestCodeService } from '@app/assets/common/test-code.service';
import type { FoundationModelDto } from '@app/assets/model/model.dto';
import { FOUNDATION_MODEL_PATH } from '@app/shared/api/api-route.config';
import { WithExportableService } from '@app/shared/api/export.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithWorkflowableService } from '@app/shared/approval/workflow.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithCrudVersionService } from '@app/shared/change-log/version.service';
import { MODEL_INPUT_TYPE } from '@app/shared/common/shared.constant';
import { WithJobService } from '@app/shared/job-history/job.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class FoundationModelService extends classes(
    WithCrudVersionService<FoundationModelDto>,
    WithAuditService,
    WithArtifactService,
    WithWorkflowableService,
    WithLogService,
    WithExportableService,
    WithLineageService,
    WithJobService,
) {
    protected endpoint = FOUNDATION_MODEL_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
    private readonly testCodeService = inject(TestCodeService);
    /**
     * Model supports Python, API, Custom as definition input type
     * @returns list of supported definition input types
     */
    getInputTypes() {
        return of({
            result: [
                {
                    name: MODEL_INPUT_TYPE.API_BASED,
                    text: 'API Based',
                },
                {
                    name: MODEL_INPUT_TYPE.PYTHON_FUNCTION,
                    text: 'Python Function',
                },
            ],
        });
    }

    runDebugCode(request: { id: number; code: string }): Observable<TestCodeEvent> {
        return this.testCodeService.run(`${this.endpoint}${request.id}/debug_code`, request.code);
    }
}
